import authedTrackingClient from './client';

export type { LockedTrackerInstance } from 'usage-tracker-core/trackerTypes';

export const createTracker = authedTrackingClient.createTracker;
